<template>
    <div>
        <div class="report-area">
            <div class="report-area-title-tag" id="page-overview">{{ $t('report.ui.overview') }}</div>
            <div class="report-area-card report-select-area" v-if="cropperiodData">
                <b-row>
                    <b-col md=4>
                        <div v-if="cropperiodData.project_logo" class="report-project-logo">
                            <!-- 專案 logo -->
                            <img v-if="cropperiodData.project_logo"
                                class="proj-logo block-sm"
                                :src="$config.checkURL('pic', cropperiodData.project_logo)"
                                :alt="cropperiodData.project_name + ' logo'" >
                        </div>
                        <div class="cropperiod-img cover-bg"
                            alt="cropperiods photo"
                            :style="$tools.style.imgCover( $config.checkURL('cropperiod', cropperiodData.pic) )"
                        ></div>
                    </b-col>
                    <b-col md=8>
                        <!-- <div class="overview-device-title">{{ $t('menu.cropping_season_information') }}</div> -->
                        <div>
                            <!-- 品種 -->
                            <h2 class="card-subtitle mb-3 agri-color-sub">
                                <i class="fa fa-leaf block-title"></i>
                                <div class="block-text">
                                    <div class="block-text" v-if="cropperiodData.cropinfo.crop_name[ user_language ]">
                                        {{ cropperiodData.cropinfo.crop_name[ user_language ] }}
                                    </div>
                                    <div v-else>{{ cropperiodData.cropinfo.crop_name.en }}</div>

                                    <div v-if="cropperiodData.cropinfo.cultivar_name[ user_language ]" class="block-text">
                                        {{ cropperiodData.cropinfo.cultivar_name[ user_language ] }}
                                    </div>
                                    <div v-else>{{ cropperiodData.cropinfo.cultivar_name.en }}</div>
                                </div>


                                <!-- Print & Share Link -->
                                <div class="block-text print-hide-object">
                                    <!-- <BtnPrint :btn_text="$t('menu.print')" btn_style="btn-cp" :btn_variant="'outline-warning'" :show_tooltip="false"></BtnPrint> -->
                                    <BtnCopyToClipboard :copy_content="report_url"
                                                        :btn_text="$t('menu.copy_report_link')"
                                                        btn_style="btn-cp" :btn_variant="'outline-warning'" :show_tooltip="false">
                                    </BtnCopyToClipboard>
                                    <BtnSavePDF v-if="user != undefined && user.id != undefined && getToken != undefined"
                                                :save_id="'print-page-top'"
                                                :save_type="'PDF'"
                                                :save_filename="report_save_name"
                                                :save_url="report_url"
                                                :save_preview="false"
                                                :log_detail="getLogDetail"
                                                :copy_content="report_url" :btn_text="$t('menu.download')"
                                                btn_style="btn-cp" :btn_variant="'outline-warning'" :show_tooltip="false">
                                    </BtnSavePDF>
                                    <BtnCopyToClipboard v-if="user_admin"
                                                        :copy_content="getDeIdentificationURL"
                                                        :btn_text="'複製簡易去識別化報告網址 (Admin)'"
                                                        btn_style="btn-cp" :btn_variant="'outline-warning'" :show_tooltip="false">
                                    </BtnCopyToClipboard>
                                </div>
                            </h2>

                            <!-- 敘述 -->
                            <div class="card-subtitle mb-2">
                                <div class="block-text">{{ cropperiodData.description }}</div>
                            </div>
                        </div>

                        <b-row>

                            <b-col cols=12 md=6>
                                <!-- 時區 -->
                                <div class="card-subtitle mb-2">
                                    <i class="fa fa-clock-o block-text"></i>
                                    <div class="block-text">{{ $t('menu.timezone') }}:</div>
                                    <div class="block-text">{{ cropperiodData.project_timezone }}</div>
                                </div>
                            </b-col>

                            <b-col cols=12 md=6>
                                <!-- 開始日期 -->
                                <div class="card-subtitle mb-2">
                                    <i class="fa fa-calendar block-text"></i>
                                    <div class="block-text">{{ $t('menu.planting_day') }}:</div>
                                    <div class="block-text">{{ cropperiodData.start_date }}</div>
                                </div>
                                <!-- 結束日期 -->
                                <div class="card-subtitle mb-2" v-if="cropperiodData.end_date">
                                    <i class="fa fa-calendar block-text"></i>
                                    <div class="block-text">{{ $t('menu.end_date') }}:</div>
                                    <div class="block-text">{{ cropperiodData.end_date }}</div>
                                </div>
                            </b-col>

                            <b-col cols=12 md=6>
                                <!-- 面積 -->
                                <div class="card-subtitle mb-2">
                                    <div class="block-text">
                                        <UnitConvertorArea :area="cropperiodData.area" :density="cropperiodData.density" defaultUnit="m2" :timezone="cropperiodData.project_timezone"
                                                        pageType="cropperiod" selectorType="dropdown"></UnitConvertorArea>
                                    </div>
                                </div>
                            </b-col>

                            <b-col cols=12 md=6>
                                <!-- 田區 -->
                                <div class="card-subtitle mb-2">
                                    <i class="cui-dashboard block-text"></i>
                                    <div class="block-text">{{ $t('n.field') }}:</div>
                                    <div class="block-text">{{ cropperiodData.farm_field }}</div>
                                </div>
                            </b-col>

                        </b-row>
                    </b-col>
                </b-row>
            </div>
            <div class="report-area-card">

                <b-row align-v="start">
                    <b-col md="8">
                            <br>
                            <!-- 積溫 Bar -->
                            <DrawCropStage  :data_growth_period="growth_period_data"
                                            :show_title="true"
                                            @cgp-data="cgp_data = $event"
                                            @cgp-list="cgp_list = $event"
                                            @cgp-now="cgp_now = $event"
                            ></DrawCropStage>
                    </b-col>
                    <b-col md="4" v-if="cgp_now">

                            <!-- 種植天數 -->
                            <div class="overview-block">
                                <div class="overview-block-title">{{ $t('menu.days_after_planting') }}</div>
                                <div class="overview-block-body">{{ cgp_now.count_past }} / {{ cgp_now.count_total }}</div>
                                <div class="overview-block-unit">{{ $t('u.days') }}</div>
                            </div>

                            <!-- 生長階段 -->
                            <div class="overview-block">
                                <div class="overview-block-title">{{ $t('menu.current_growth_stage') }}</div>
                                <div class="overview-block-body">{{ cgp_now.name[ user_language ] }} {{ cgp_now.period[ 0 ] }}</div>
                                <div class="overview-block-unit">{{ $t('u.days') }}</div>
                            </div>

                            <!-- 下一個生長階段 -->
                            <div class="overview-block" v-if="cgp_now.next">
                                <div class="overview-block-title">{{ $t('menu.days_to_next_stage') }}</div>
                                <div class="overview-block-body">{{ cgp_now.next.day_next }}</div>
                                <div class="overview-block-unit">{{ $t('u.days') }}</div>　=>　
                                <div class="overview-block-body">{{ cgp_now.next.name[ user_language ] }}</div>
                            </div>

                            <br>
                    </b-col>

                </b-row>
                <b-row align-v="start">

                    <b-col md="12" v-if="deviceInfo && Object.keys(deviceInfo).length > 0">
                        <div>
                            <div class="overview-device-title">{{ $t('n.device') }}</div>
                        </div>
                        <b-row>
                            <b-col sm=6 xl=4 v-for="(device, key_device, idx_device) in deviceInfo" :key="idx_device">
                                <div class="overview-device-block scroll-style-gray">

                                    <div class="device-info">
                                        <div class="device-up-info print-hide-object" v-if="user_admin">ID={{ device.id }}</div>

                                        <div class="device-name">
                                            <i :class="$tools.style.classIcon(device.type, 'block-title')"></i>
                                            <span v-if="device.nickname">{{ device.nickname }}</span>
                                            <span v-else>{{ device.hashid }}</span>
                                        </div>
                                    </div>
                                    <div class="device-down-info">
                                        <div>
                                            {{ $t('n.' + device.type) }}
                                            {{ key_device }}
                                        </div>
                                        <div>
                                            <i class="fa fa-map-marker"></i>
                                            [ {{ device.latitude }} , {{ device.longitude }} ]
                                        </div>
                                        <div class="device">
                                            <div v-for="(ds, idx_ds) in device.params" :key="idx_ds" class="device-sensor-blocks">
                                                {{ $t('sensor.' + ds) }}<div class="device-unit" v-html="$t('sensor.u_' + ds)"></div>
                                            </div>
                                        </div>
                                        <div v-if="device.description" class="device-description" v-html="device.description"></div>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>

                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import DrawCropStage from '@/views/components/Draw_CropStage'
import BtnCopyToClipboard from '@/views/components/Button_CopyToClipboard'
import BtnSavePDF from '@/views/components/Button_SavePDF'
import BtnPrint from '@/views/components/Button_Print'
import UnitConvertorArea from '@/views/components/UnitConvertor_Area'

export default {
    props: {
        cropperiodData: {
            type: Object,
            required: true,
        },
        deviceInfo: {
            type: Object,
            default: {},
        },
        growth_period_data: {
            type: Array,
        },
        user: {
            type: Object,
            default: undefined,
        },
        report_url: {
            type: String,
            default: '',
        },
        report_save_name: {
            type: String,
            default: '',
        },
    },
    components: {
        DrawCropStage,
        BtnCopyToClipboard,
        BtnSavePDF,
        BtnPrint,
        UnitConvertorArea,
    },
    data () {
        return {
            cgp_data: undefined,
            cgp_list: undefined,
            cgp_now: undefined,
        }
    },
    mounted ()
    {

    },
    computed: {
        ...mapState({
            'user_language': state => state.user.language,
            'user_admin': state => state.user.is_admin,
        }),

        getDeIdentificationURL ()
        {
            return this.report_url.replace('?id=', '?ids=')
        },

        getToken ()
        {
            return localStorage.token
        },

        getLogDetail ()
        {
            return {
                page: 'report monthly',
                action: 'download pdf',
                querySettings: {
                    'project ID':       this.cropperiodData.project_id,
                    'cropperiod ID':    this.cropperiodData.id,
                    'cropperiod name':  this.cropperiodData.name,
                    'report name':      this.date_month + ' ' + this.$t('menu.analysis_report'),
                    'report type':      'monthly',
                    'report range':     this.date_range,
                    'report ID':        this.$route.query.id,
                    'report url':       this.report_url,
                },
                pageInfo: {
                    'project timezone':     this.cropperiodData.project_timezone,
                    'project status':       this.cropperiodData.project_status,
                },
            }
        },

    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>

.scroll-style-gray
{
    cursor: default !important;
}

.overview-block
{
    vertical-align: top;
    margin: 5px 20px 5px 10px;
    font-size: 1.2rem;
}
.overview-block-title
{
    display: inline-block;
    // vertical-align: middle;
    margin-bottom: -2px;
    margin-right: 10px;
}
.overview-block-body
{
    display: inline-block;
    // vertical-align: middle;
    font-size: 1.8rem;
    color: #008060;
    border-bottom: 1px solid #c3e7e5;
}
.overview-block-unit
{
    display: inline-block;
    // vertical-align: bottom;
    margin-left: 10px;
}
.overview-device-title
{
    display: inline-block;
    font-size: 1.5rem;
    color: #385f53;
    border-bottom: 1px solid #b8da8c;
    padding: 1px 15px 1px 8px;
    margin-bottom: 10px;
}
.overview-device-block
{
    max-width: 100%;
    max-height: 150px;
    padding: 5px;
    margin-bottom: 10px;

    overflow-x: hidden;
    overflow-y: auto;//scroll;

    .device-sensor-blocks
    {
        color: #33443b;
        font-size: 0.8rem;
    }

    .device-info
    {
        display: inline-block;
        margin-right: 10px;
    }
    .device-hashid
    {
        font-size: 0.8rem;
        margin-left: 8px;
    }
    .device-deviceid {
        font-size: 0.75rem;
        margin-left: 5px;
    }

    .device-name
    {
        display: inline-block;
        font-size: 1.2rem;
        margin-right: 5px;
        i {
            color: #cea212;
        }
    }
    .device-up-info
    {
        //display: inline-block;
        margin-left: 30px;
        margin-bottom: -3px;
        color: #747974;
    }
    .device-down-info
    {
        margin-left: 25px;
        margin-top: -5px;
        margin-right: 5px;
        color: #747974;
    }
    .device-description
    {
        margin-bottom: 5px;
    }
}

</style>
